// extracted by mini-css-extract-plugin
var _1 = "TableCellFreeSpaceFiller-moduleTableCellFreeSpaceFiller__Tup2H";
export { _1 as "TableCellFreeSpaceFiller" }
